import { axiosApi } from "../../../../../../../api/dbAxios";

export const fetchGroupEmailList = async () => {
  try {
    const test_email = "ykozak@deloittece.com";
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";
    const response = await axiosApi.get("/users_groups/", {
      params: isLocalhost ? { test_email } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Email Group list:", error);
    return [];
  }
};
